import { useEffect } from 'react';

import { isExisty } from 'utils/helpers.util';

import { IDeliverTo } from 'pages/Checkout/types/deliverTo.types';

const useDeliverToStatus = (
  deliverTo: boolean,
  deliverToState: IDeliverTo,
  setStepDeliverToStatus: (flag: boolean) => any
): void => {
  useEffect(() => {
    const dynamicStatus = isExisty(deliverToState.value);
    if (deliverTo !== dynamicStatus) {
      setStepDeliverToStatus(dynamicStatus);
    }
  }, [deliverTo, deliverToState, setStepDeliverToStatus]);
};

export default useDeliverToStatus;
